import React from 'react'
import { Menu } from 'semantic-ui-react'

import "../../containers/App.css";
import "./navbar.css";

const Navbar = () => (
  <div>
    <Menu fixed='top' vertical fluid>
      <h1>Where in the World? </h1>  
    </Menu>
  </div>
    

)

export default Navbar;